import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import type { CommonStoreState } from '../store'
import { useFormContext } from 'react-hook-form'
import { Input } from '@panwds/react-form'
import { Validation } from './SubDomainField'
import { REGION_FIELD_NAME, TSG_FIELD_NAME } from './common/GlobalConstants'
import { Banner } from '@panwds/react-ui'
import { APP_ID_IOT, APP_ID_SAASINLINE, AIOPS_APP_ID } from '../constants'
import UAccordionHeader from './unified/UAccordionHeader'


export interface ProfileSubscriptionUrlProps {
  state: CommonStoreState;
  title: string;
  subtitle?: string;
  updateTitle: (title: any) => void;
  setAccordionOpen: (isOpen: boolean) => void;
  setDisable: (disable: boolean) => void;
}
export interface deploymentProfileConfig {
  app_id: string;
  package_version?: number;
  domain: string
}
const ProfileSubscriptionUrl = (props: ProfileSubscriptionUrlProps) => {
  const { setValue, setError, clearErrors, watch, getValues } = useFormContext()
  const { state, title, subtitle, setDisable } = props
  const { context, instances, tsg, apps, globalTsgId } = state
  const [subExistingDomain, setSubExistingDomain] = useState<string | undefined>()
  const current_deployment_profiles = watch('deployment_profiles')
  const [domainPostFix, setDomainPostFix] = useState<any>({})
  const [profileConfig, setProfileConfig] = useState<deploymentProfileConfig[]>([])
  const [isIoTFQDNRequired, setIsIoTFQDNRequired] = useState<boolean>(false)
  const region = getValues(REGION_FIELD_NAME)
  const dpTsgId = getValues(TSG_FIELD_NAME)?.id
  const tsgId = tsg?.tsg_id || globalTsgId
  const supportedApps = [APP_ID_IOT, APP_ID_SAASINLINE, AIOPS_APP_ID]
  useEffect(() => {
    const _domainPostFix: any = {}
    // console.log('context', context)
    supportedApps.forEach(app_id => {
      const appDef = apps.find(e => e.app_id === app_id)
      const postfixDomain = appDef?.regions?.find(e => e.name === region?.id)?.domain_postfix || appDef?.domain_postfix

      _domainPostFix[app_id] = {
        domainPostFix: postfixDomain
      }
    })
    // console.log('_domainPostFix', _domainPostFix)
    setDomainPostFix(_domainPostFix)
  }, [])

  useEffect(() => {
    if (current_deployment_profiles) {
      setDisable(false)
      const c = current_deployment_profiles?.map((dps: any) => dps.subscriptions).flat(1)
      const profileConfig: deploymentProfileConfig[] = []

      supportedApps.forEach(app_id => {
        let IoTPackageConfig
        const hasAppConfig = c.find((cs: { app_id: any }) => cs.app_id === app_id)
        const appInstance = instances?.find((i) => i.app_id === app_id)
        if (hasAppConfig) {
          if (app_id === APP_ID_IOT) {
            const hasIoTPackage1 = c.find((cs: { package_version: number }) => cs.package_version === 1)
            IoTPackageConfig = { package_version: hasIoTPackage1 ? 1 : 2 }
            if (appInstance) {
              setSubExistingDomain(appInstance?.url?.replace('https://', ''))
              setValue('zingbox-subdomain', appInstance?.url?.replace('https://', ''))
            }
            else {
              setSubExistingDomain('')
              setValue('zingbox-subdomain', '')
            }
          }
          profileConfig.push({
            app_id,
            domain: '',
            ...(IoTPackageConfig ? IoTPackageConfig : {})
          })
        }
      })
      setProfileConfig(profileConfig)
      setValue('subscriptions', profileConfig)
      setIsIoTFQDNRequired(Boolean(profileConfig.find((p) => p.app_id === APP_ID_IOT)))
      // setIsSaaSFQDNRequired(Boolean(profileConfig.find((p) => p.app_id === APP_ID_SAASINLINE)))
    }
    else {
      setDisable(true)
    }

  }, [current_deployment_profiles, setProfileConfig, instances])
  const onInputChange = (event: any) => {
    if (event.currentTarget.name === 'iot-subdomain') {
      // console.log('value', event.currentTarget.value)
    }

  }
  // useEffect(() => {
  //   console.log('instances', instances)
  // }, [instances])
  // const isIoTEnabled = useMemo(() => {
  //   console.log('iot profile')
  //   if (!profileConfig.length) {
  //     return true
  //   }
  //   return profileConfig.find(each => each.app_id === APP_ID_IOT)
  // }, [profileConfig])
  // const isSaaSEnabled = useMemo(() => {
  //   console.log('saas profile')
  //   if (!profileConfig.length) {
  //     return true
  //   }
  //   return profileConfig.find(each => each.app_id === APP_ID_SAASINLINE)
  // }, [profileConfig])

  // const renderedUrlField = useMemo(() => {
  //   if (!profileConfig.length) {
  //     return <Banner
  //       type='inline'
  //       showIcon
  //       appearance={'warning'}
  //     >
  //       The selected Customer Support Account does not have any available Deployment Profiles.
  //     </Banner>
  //   }
  //   return profileConfig.map((app_id, index) => {
  //     console.log('each', app_id)
  //     return (
  //       <div className='cm-flex cm-flex-row cm-pt-2' key={index}>
  //         <div className="tw-pl-1 tw-py-1">
  //           IoT
  //         </div>
  //         <div className="tw-pl-6">
  //           <Input
  //             disabled={Boolean(subExistingDomain) || !Boolean(dpTsgId)}
  //             label={''}
  //             value={subExistingDomain || currentTypedInIoTSubDomain}
  //             showLabel={true}
  //             style={{ textTransform: 'lowercase' }}
  //             placeholder="url Subdomain"
  //             addClassName="tw-w-64"
  //             name='iot-subdomain'
  //             data-testid='activation-zingbox-sub-domain'
  //             data-metrics='activation-zingbox-sub-domain'
  //             onInput={(e) => setCurrentTypedInIoTSubDomain(e.currentTarget.value)}
  //             register={{
  //               validate: Validation({
  //                 tsgId,
  //                 globalTsgId,
  //                 subExistingDomain,
  //                 domainPostFix: domainPostFix[`${app_id}`]?.domainPostFix,
  //                 appId: app_id,
  //                 validationRules: { validation_required: !subExistingDomain }
  //               }),
  //             }}
  //           />
  //         </div>

  //         <div className="tw-pl-3 tw-py-1">{domainPostFix[`${app_id}`]?.domainPostFix}</div>
  //       </div>
  //     )
  //   })
  // }, [profileConfig])
  // console.log('isIoTFQDNRequired', isIoTFQDNRequired)
  // console.log('isSaaSFQDNRequired', isSaaSFQDNRequired)
  return (
    <>
      <UAccordionHeader title={title || ''} subtitle={subtitle || ''} />
      {/* {renderedUrlField} */}
      <div style={{ minHeight: '60px' }} className='cm-h-full'>
        {isIoTFQDNRequired && (
          <div className="cm-flex">
            <div className="cm-flex-none">IoT</div>
            {!subExistingDomain && (
              <div className="cm-flex-none w-16 cm-pl-4">
                <Input
                  disabled={Boolean(subExistingDomain) || !Boolean(dpTsgId)}
                  label={''}
                  //value={subExistingDomain || currentTypedInIoTSubDomain}
                  showLabel={true}
                  style={{ textTransform: 'lowercase' }}
                  placeholder="url Subdomain"
                  addClassName="tw-w-64"
                  name='zingbox-subdomain'
                  data-testid='activation-zingbox-sub-domain'
                  data-metrics='activation-zingbox-sub-domain'
                  //onInput={(e) => onInputChange(e)}
                  register={{
                    onBlur: ((e) => {
                      onInputChange(e)
                    }),
                    validate: Validation({
                      tsgId,
                      globalTsgId,
                      subExistingDomain,
                      domainPostFix: domainPostFix[APP_ID_IOT]?.domainPostFix,
                      appId: APP_ID_IOT,
                      validationRules: { validation_required: !subExistingDomain }
                    }),
                  }}
                />
              </div>
            )}
            {!subExistingDomain && (
              <div className="cm-flex-1 w-64 cm-pl-2">
                {domainPostFix[APP_ID_IOT]?.domainPostFix}
              </div>
            )}
            {subExistingDomain && (
              <div className="cm-flex-1 w-32 cm-pl-4">
                <span>{subExistingDomain}</span>
              </div>
            )}
          </div>
        )}
        {!isIoTFQDNRequired ? (<div className='cm-mt-4'>
          <Banner
            type='inline'
            showIcon
            appearance={'warning'}
          >
            The selected Deployment Profiles doesnt need url config.
          </Banner>
        </div>) : ''}
      </div>
    </>
  )

}

export default ProfileSubscriptionUrl
